import { render } from "./RetailTr.vue?vue&type=template&id=53cc3d0c&scoped=true"
import script from "./RetailTr.vue?vue&type=script&lang=js"
export * from "./RetailTr.vue?vue&type=script&lang=js"

import "./RetailTr.vue?vue&type=style&index=0&id=53cc3d0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cc3d0c"]])

export default __exports__